const UpdateCartItems = {
  plusButton: '.cart .qtyBtn.plus',
  minusButton: '.cart .qtyBtn.minus',
  removeButton: '.cart .cart__remove',
  updateButton: '.cart-update',
  updateQtyInput: '.cart .cart__qty-input',
  proceedCheckoutButton: '#cartCheckout',
  redirection: 'cart',
  requestInProgress: false, 
  pathAjax: `${location.protocol}//${location.host}${location.pathname}?sections=cart-template,cart_object`,
  _init: function () {
    this._addClickEventAddOrRemove();
    this._addClickEventRemove();
    this._addChangeEventQty();
  },
  _preEventActions: async function() {
    $('body').addClass('loading');
  },
  _postEventActions: async function() {
    var self = this;
    const totalItems = CartJS.cart.items.length;
    if(totalItems < 1) {
      self._cleanCartUi();
    }else {
      const totalItemsInCart = CartJS.cart.items.reduce((total_items, item) => {
        if(typeof surchargeVariantId !== 'undefined' && item.id == surchargeVariantId) return total_items;
        return total_items + item.quantity;
    },0);
      let fulltext = (totalItemsInCart > 1 ? (totalItemsInCart + " items"): (totalItemsInCart + " item"))
      $('#asm-subtotal-title .items-count')?.html(fulltext);
    }
    forcetoUpdateASMwoZIP();
    updateSections(self.pathAjax, 1);
    // FCP-01 - after any CartJS event
    // $('#cartItemsId tbody').removeClass('overlay');
    // $('#asm-mini-cart').removeClass('overlay');
  },
  _addClickEventAddOrRemove: function () {
    var self = this;
    $('.cart').on("click", `${this.plusButton}, ${this.minusButton}`, async function() {
      if(!$(this).hasClass('disabled') && $(this).closest('#cartItemsId tbody').length) {
        await self._preEventActions();
        const row = $(this).closest('.cart__row');
        const variantId = row.data('variant-id');
        const action = $(this).attr("data-action");
        const currentQty = parseInt($(this).parent().find('.cart__qty-input').attr('value'));
        const newQty = action == "plus" ? parseInt(currentQty) + 1 : parseInt(currentQty) - 1;
        // $(this).parent().find('.cart__qty-input').val(newQty).change();
        var index = row.data('index');
        self._updateCartJsByVariant(variantId, newQty, index);
        UpdatePriceOnCarts(newQty);
      }
    });
  },
  _addClickEventRemove: function () {
    var self = this;
    $('.cart').on("click", this.removeButton, async function() {
      if($(this).closest('#cartItemsId tbody').length) {
        await self._preEventActions();
        const row = $(this).parents('.cart__row');
        const variantId = row.data('variant-id');
        const newQty = 0;
        self._updateCartJsByVariant(variantId, newQty);
        var cartIndexVal = $(this).closest('.cart-flex').data( "install-enabled" );             
        if(typeof items === 'undefined') return;
        if(cartIndexVal===true){
          //enabledInstallationProductsCountJS=enabledInstallationProductsCountJS-1;
          rivets.formatters.checkVendorLogo(items, cartIndexVal);
        } 
        else if (cartIndexVal===''){
          rivets.formatters.checkVendorLogo(items, cartIndexVal);
          itemsEnableInstallationMissingCountJS=itemsEnableInstallationMissingCountJS-1;
        } 
        else if (cartIndexVal===false){
          rivets.formatters.checkVendorLogo(items, cartIndexVal);
        }
      }
    });
  },
  _addChangeEventQty: function() {
    var self = this;
    $(document).on('change', this.updateQtyInput, async function(e) {
      if($(this).closest('#cartItemsId tbody').length) {
        let min_quantity = parseInt($(this).attr('data-min') != ""?$(this).attr('data-min'): 1);
        let max_quantity = parseInt($(this).attr('data-max'));
        let item_id = $(this).attr('data-item');
        let current_value = $(this).val();
        if(min_quantity && current_value <= min_quantity ){
          $(this).parents('.qtyField').find('.minus').addClass('disabled');
          if(current_value < min_quantity){
            $(this).val(min_quantity);
            window.cart_min_max_error = {
              id: item_id,
              validation: "min",
              min_quantity: min_quantity,
              max_quantity: max_quantity
            }
          }
        }else{
          $(this).parents('.qtyField').find('.minus').removeClass('disabled');
        }
        if(max_quantity && current_value >= max_quantity ){
          $(this).parents('.qtyField').find('.plus').addClass('disabled');
          if(current_value > max_quantity){
            $(this).val(max_quantity);
            window.cart_min_max_error = {
              id: item_id,
              validation: "max",
              min_quantity: min_quantity,
              max_quantity: max_quantity
            }
          }
        }else{
          $(this).parents('.qtyField').find('.plus').removeClass('disabled');
        }
        if(window.isCartPage){
          $('body').addClass('loading');
        }
        let newQty = parseInt($(this).val());
        if(newQty !== null && newQty !== '' && newQty !== undefined && newQty > -1) {
          UpdatePriceOnCarts(newQty);  
          const row = $(this).closest('.cart__row');
          const variantId = row.data('variant-id');
          var index = row.data('index');
          if(newQty == 0){
            self._updateCartJsByVariant(variantId, 1, index);
          }else{
            self._updateCartJsByVariant(variantId, newQty, index);
          }
          
        } else {
          //alert('Invalid quantity');;
        }
      }
    });
  },
  _handleInstallation: async function(idInstallation, installationCost, addInstallation) {
    if(CartJSItems) {
      let variantId = this._getVariantId(idInstallation, 'installation_');
      let itemCart = CartJSItems.filter(item => item.key.includes(variantId));
      if(!itemCart.length) {
        return
      }
      itemCart = itemCart[0];
      let cartItemKey = itemCart.key;
      let properties = itemCart.properties;
      const {_bundleInstallationService, ...rest} = itemCart.properties;
      properties = rest;
      await this._changeOneItemCart({ id: cartItemKey, properties });
      CartJSItems = CartJSItems.map(item => {
        if(item.key.includes(variantId)) {
          item.properties = properties;
        }
        return item;
      });
    }
  },
  _cleanCartUi: function() {
  
  },
  _updateCartJsByVariant: function(variantId,newQty){
    var self = this;
    const CartJSItems = CartJS.cart.items;
    const itemIndex = CartJSItems.findIndex(({variant_id}) => variant_id === variantId);
    const itemIndexToUpdate = itemIndex + 1;
    const {variant_id,quantity,handle,properties} = CartJSItems[itemIndex];
    
    // Maintain cart attributes
    let newProperties = { ...properties };
    
    CartJS.updateItem(itemIndexToUpdate, newQty, newProperties, {
        "success": function(data, textStatus, jqXHR) {
            // Handle success callback
            self._handleInstallationVisibility(data.items);
            // Check upsell is enable or not and if enable then only call the upsell functions 
            if(upSellDisable == false){
              volMiniCartComponentSelected(data.items);
            }
        }
    });
},

  _handleInstallationVisibility: function(cartItems) {
    const installationWrapper = $('.js-cart-installation-wrapper')
    const installationItem = $('.cmp-installation');
    const sampleItems = cartItems.filter(item => item.handle.includes('sample'));
    let onlySamples = sampleItems.length === cartItems.length;
    if(onlySamples && installationItem.css('display') === 'block') {
      installationItem.css('display', 'none');
      installationWrapper.css('display', 'none');
      installationItem.addClass('hideBySamples');
    }else if(installationItem.hasClass('hideBySamples') && installationItem.css('display') === 'none') {
      installationItem.css('display', 'block');
      installationWrapper.css('display', 'block');
    }  
  },
  _checkByVariant: function(variantId,install,installationcost,wrapper,qty) {
    const CartJSItems = CartJS.cart.items;
    const itemIndex = CartJSItems.findIndex(({variant_id}) => variant_id === variantId);
    const itemIndexToUpdate = itemIndex + 1;
    const {variant_id,quantity,handle,properties} = CartJSItems[itemIndex];
    
    const newProperties = {...properties};
    if(install){
      newProperties['_bundleInstallationService'] = installationcost;
    } else if( typeof newProperties._bundleInstallationService !== 'undefined'){
      delete newProperties._bundleInstallationService;
    }
    $(wrapper).addClass('loading');
    CartJS.updateItem(itemIndexToUpdate,quantity,newProperties,{
      "success": function(data, textStatus, jqXHR) {
        $('.loading').removeClass('loading');
      },
    });
  },
  _updateCart: async function(items, itemsToDelete) {
    try {
      const deleteResponse = await fetch('/cart/update.js', this._getRequestRoute({updates: itemsToDelete}));
      if (!deleteResponse.ok) throw new Error('Problem removing cart items');
      const addResponse = await fetch('/cart/add.js', this._getRequestRoute({items: items}));
      if (!addResponse.ok) throw new Error('Problem adding cart items');
      if(this.redirection === 'cart') {
        location.reload();
      } else {
        document.location.href = '/cart/checkout';
      }
    } catch(err){
      console.log(err)
    }
  },
  _updateOneItemCart: async function(items) {
    try {
      const response = await fetch('/cart/update.js', this._getRequestRoute({updates: items}));
      if (!response.ok){
        return null;
      }
      return await response.json();
    }catch(err){
      return null;
    }
  },
  _changeOneItemCart: async function(items) {
    try {
      const response = await fetch('/cart/change.js', this._getRequestRoute(items));
      if (!response.ok){
        return null;
      }
      return await response.json();
    }catch(err){
      return null;
    }
  },
  _getRequestRoute: function(object) {
    return {method: 'POST', headers: {'Content-Type': 'application/json'}, body: JSON.stringify(object)}
  },
  _getVariantId: function(str, removePrefix = null) {
    if(removePrefix){
      return str.replace(removePrefix, '').split(':')[0]
    }
    return str.split(':')[0]
  }
}

$( document ).on("ready", function() {
  UpdateCartItems._init();
});